const API_BASE_URL = 'https://jzptapp.com/api/v1'; // Replace with actual backend URL

export async function trainerLogin(credentials) {
  try {
    const response = await fetch(API_BASE_URL + '/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });
    if (!response.ok) {
      throw new Error('Invalid username or password');
    }
    return await response.json();
  } catch (error) {
    console.error('Error logging in trainer:', error);
    throw error;
  }
}

export async function sendRegistrationData(data) {
  try {
    const response = await fetch(API_BASE_URL + '/registrations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Failed to send registration data');
    }
    return await response.json();
  } catch (error) {
    console.error('Error sending registration data:', error);
    throw error;
  }
}

export async function sendConfirmationEmail(data) {
  try {
    const response = await fetch(API_BASE_URL + '/send-confirmation-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Failed to send confirmation email');
    }
    return await response.json();
  } catch (error) {
    console.error('Error sending confirmation email:', error);
    throw error;
  }
}

export async function fetchLocations() {
  try {
    const response = await fetch(API_BASE_URL + '/locations');
    if (!response.ok) {
      throw new Error('Failed to fetch locations');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
}
export async function fetchTerms(registrationType) {
  try {
    const response = await fetch(API_BASE_URL + '/termsandconditions?type='+registrationType);
    if (!response.ok) {
      throw new Error('Failed to fetch locations');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching termsandconditions:', error);
    throw error;
  }
}

